export default "__VITE_ASSET__BURxmbv___"